import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TriggerGroupEntity } from './trigger-group.entity';
import { TriggerEntity } from './trigger.entity';

// Covers the legacy server's setTriggerGroupState iteration COUNTs (5 equality
// predicates + optional _created_date range). Without it those COUNTs scan
// ~330k rows per trigger firing — 14s each on pharmsource's 1.3M-row table.
@Index(
	'_trigger_group_state_history_state_lookup',
	[
		'fkTriggerGroupId',
		'fkTriggerId',
		'resourceId',
		'fkObjectId',
		'result',
		'createdDate',
	],
	{},
)
@Index('_resourceId', ['deletedUserId', 'resourceId'], {})
@Index('_trigger_group_state_history__fk__audit__id_fk', ['fkAuditId'], {})
@Index('_trigger_group_state_history__fk__trigger__id_fk', ['fkTriggerId'], {})
@Index(
	'_trigger_group_state_history__fk__trigger_group__id_fk',
	['fkTriggerGroupId'],
	{},
)
@Entity('_trigger_group_state_history')
export class TriggerGroupStateHistoryEntity extends BaseEntity {
	@Column('int', { name: '_fk__trigger_group__id', unsigned: true })
	public fkTriggerGroupId!: number;

	@Column('int', { name: '_fk__trigger__id', unsigned: true })
	public fkTriggerId!: number;

	@Column('int', { name: '_resourceId', unsigned: true })
	public resourceId!: number;

	@Column('int', { name: '_fk__audit__id', nullable: true, unsigned: true })
	public fkAuditId!: number | null;

	@Column('int', { name: '_totalIterations', default: () => "'0'" })
	public totalIterations!: number;

	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('varchar', { name: '_result', nullable: true, length: 255 })
	public result!: string | null;

	@ManyToOne(
		() => TriggerGroupEntity,
		(triggerGroup) => triggerGroup.triggerGroupStateHistories,
		{ onDelete: 'CASCADE', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__trigger_group__id', referencedColumnName: 'id' }])
	public fkTriggerGroup!: TriggerGroupEntity;

	@ManyToOne(
		() => TriggerEntity,
		(trigger) => trigger.triggerGroupStateHistories,
		{
			onDelete: 'CASCADE',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: '_fk__trigger__id', referencedColumnName: 'id' }])
	public fkTrigger!: TriggerEntity;
}
